import _get from "D:\\NETINDO\\web\\alfar\\npos-bo-alfar\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _classCallCheck from "D:\\NETINDO\\web\\alfar\\npos-bo-alfar\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\NETINDO\\web\\alfar\\npos-bo-alfar\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\NETINDO\\web\\alfar\\npos-bo-alfar\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\NETINDO\\web\\alfar\\npos-bo-alfar\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\NETINDO\\web\\alfar\\npos-bo-alfar\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
import { DecodeStream } from './DecodeStream.js';
import { Base } from './Base.js';
var NumberT = /*#__PURE__*/function (_Base) {
  _inherits(NumberT, _Base);
  function NumberT(type) {
    var _this;
    var endian = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'BE';
    _classCallCheck(this, NumberT);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumberT).call(this));
    _this.type = type;
    _this.endian = endian;
    _this.fn = _this.type;
    if (_this.type[_this.type.length - 1] !== '8') {
      _this.fn += _this.endian;
    }
    return _this;
  }
  _createClass(NumberT, [{
    key: "size",
    value: function size() {
      return DecodeStream.TYPES[this.type];
    }
  }, {
    key: "decode",
    value: function decode(stream) {
      return stream["read".concat(this.fn)]();
    }
  }, {
    key: "encode",
    value: function encode(stream, val) {
      return stream["write".concat(this.fn)](val);
    }
  }]);
  return NumberT;
}(Base);
export { NumberT as Number };
export var uint8 = new NumberT('UInt8');
export var uint16be = new NumberT('UInt16', 'BE');
export var uint16 = uint16be;
export var uint16le = new NumberT('UInt16', 'LE');
export var uint24be = new NumberT('UInt24', 'BE');
export var uint24 = uint24be;
export var uint24le = new NumberT('UInt24', 'LE');
export var uint32be = new NumberT('UInt32', 'BE');
export var uint32 = uint32be;
export var uint32le = new NumberT('UInt32', 'LE');
export var int8 = new NumberT('Int8');
export var int16be = new NumberT('Int16', 'BE');
export var int16 = int16be;
export var int16le = new NumberT('Int16', 'LE');
export var int24be = new NumberT('Int24', 'BE');
export var int24 = int24be;
export var int24le = new NumberT('Int24', 'LE');
export var int32be = new NumberT('Int32', 'BE');
export var int32 = int32be;
export var int32le = new NumberT('Int32', 'LE');
export var floatbe = new NumberT('Float', 'BE');
export var float = floatbe;
export var floatle = new NumberT('Float', 'LE');
export var doublebe = new NumberT('Double', 'BE');
export var double = doublebe;
export var doublele = new NumberT('Double', 'LE');
export var Fixed = /*#__PURE__*/function (_NumberT) {
  _inherits(Fixed, _NumberT);
  function Fixed(size, endian) {
    var _this2;
    var fracBits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : size >> 1;
    _classCallCheck(this, Fixed);
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Fixed).call(this, "Int".concat(size), endian));
    _this2._point = 1 << fracBits;
    return _this2;
  }
  _createClass(Fixed, [{
    key: "decode",
    value: function decode(stream) {
      return _superPropGet(Fixed, "decode", this, 3)([stream]) / this._point;
    }
  }, {
    key: "encode",
    value: function encode(stream, val) {
      return _superPropGet(Fixed, "encode", this, 3)([stream, val * this._point | 0]);
    }
  }]);
  return Fixed;
}(NumberT);
export var fixed16be = new Fixed(16, 'BE');
export var fixed16 = fixed16be;
export var fixed16le = new Fixed(16, 'LE');
export var fixed32be = new Fixed(32, 'BE');
export var fixed32 = fixed32be;
export var fixed32le = new Fixed(32, 'LE');